<template>
  <main-body>
    <div class="d-flex justify-end" style="font-size: small; margin-top: 0px; margin-bottom: 5px">
      총 건수: {{ summary.totalCount }},
      중복 건수: {{ numberFormat(summary.duplicatedCount) }},
    </div>

    <div class="main-con">
      <!--매출 확인 버튼 클릭시 나오는 모달 시작-->
      <sales-modal :dialog="dialog" :sales-list-click-auto-setting-data="salesListClickAutoSettingData"
                   @close-modal="closeSalesModal"
      />

      <table class="data-table" style="table-layout: fixed">
        <thead style="z-index: 1">
        <tr>
          <th class="width-pixel-60" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyId')">
            임대번호
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('rentalcompanyName')">
            임대업체명
          </th>
          <th class="width-pixel-80" style="cursor: pointer;" @click="sortOptionChange('accountId')">
            거래처번호
          </th>
          <th style="cursor: pointer;" @click="sortOptionChange('accountName')">
            거래처명
          </th>
          <th class="width-pixel-90" style="cursor: pointer;" @click="sortOptionChange('billingType')">
            생성 유형
          </th>
          <th class="width-pixel-80" style="cursor: pointer;" @click="sortOptionChange('targetCount')">
            품목계약번호
          </th>
          <th class="width-percent-8" style="cursor: pointer;" @click="sortOptionChange('targetPriceSum')">
            예상 금액
          </th>
          <th class="width-pixel-60" style="cursor: pointer;" @click="sortOptionChange('createdCount')">
            생성 건수
          </th>
          <th class="width-percent-8" style="cursor: pointer;" @click="sortOptionChange('createdPriceSum')">
            생성 금액
          </th>
          <th class="width-pixel-100" style="cursor: pointer;" @click="sortOptionChange('besideCount')">
            당월 생성 건수
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('besidePriceSum')">
            당월 생성 금액
          </th>
          <th class="width-pixel-100" style="cursor: pointer;" @click="sortOptionChange('usageCount')">
            추가 사용 건수
          </th>
          <th class="width-percent-10" style="cursor: pointer;" @click="sortOptionChange('usagePriceSum')">
            추가 사용 금액
          </th>
          <th class="width-pixel-80">
            매출 확인
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, index) in items" :key="index" :style="markConditionStyle(index)" @click="openModal(item)">


          <!--중복매출 바디-->
          <template>
            <td class="table-text-center">
              {{ item.rentalcompanyId }}
            </td>
            <td class="short-text" :title="item.rentalcompanyName">
              {{ item.rentalcompanyName }}
            </td>
            <td class="table-text-center" @click="openModal(item)">
              {{ item.accountId }}
            </td>
            <td class="short-text" :title="item.accountName">
              {{ item.accountName }}
            </td>
            <td>{{ item.billingType }}</td>
            <td class="table-text-right">
              {{ item.printerContractId }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.targetPriceSum) }}
            </td>
            <td class="table-text-right">
              {{ item.createdCount }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.createdPriceSum) }}
            </td>
            <td class="table-text-right">
              {{ item.besideCount }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.besidePriceSum) }}
            </td>
            <td class="table-text-right">
              {{ item.usageCount }}
            </td>
            <td class="table-text-right">
              {{ numberFormat(item.usagePriceSum) }}
            </td>
            <td class="table-text-center">
              <v-btn
                  color="primary"
                  dark
                  x-small
                  @click.stop="openSalesModal(item.rentalcompanyId,item.accountName)"
              >
                매출확인
              </v-btn>
            </td>
          </template>
        </tr>
        </tbody>
      </table>
    </div>
    <div
        class="infinity_scroll_table_paging"
    >
      <v-container>
        <v-row justify="center">
          <v-col cols="8">
            <v-container class="max-width">
              <v-pagination
                  v-model="page"
                  class="my-4"
                  :length="pageLength"
              />
            </v-container>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div v-show="isLoading" class="loading_wrap">
      <div class="loading" />
      <div class="loading" />
      <div class="loading" />
    </div>
  </main-body>


</template>


<script>
import {PATH} from "@/constants";
import MainBody from "@/components/common/layout/MainBody.vue";
import SalesModal from "@/views/batch/SalesModal.vue";

export default {
  name: "BatchCheckDuplicateBillsComp",
  components: {
    SalesModal,
    MainBody,
  },
  props: {
    searchOptions: {
      type: Object
    },
    identifier: {
      type: Number
    }

  },
  data() {
    return {
      items: [],
      dialog: false,
      dataTotalCount: 0,
      summary: {
        totalCount:0,
        duplicatedCount: 0,
      },
      isLoading: false,
      page: 1,
      isSummaryLoading: false,
      sortOption: {
        sortBy: [],
        sortDesc: [],
      },
      salesListClickAutoSettingData: { //매출 확인 버튼 클릭시 전달할 데이터를 가공하기 위함입니다.
        rentalcompanyId: undefined,
        companyName: undefined
      },
    }
  },

  computed: {
    pageLength() {
      if (!this.dataTotalCount) return 1
      return Math.ceil(this.dataTotalCount / this.searchOptions.pageSize)
    },
  },
  watch: {
    'searchOptions.pageNumber'(newValue, oldValue) {
      this.page = newValue
    },
    page(newValue, oldValue) {
      this.onLoad(newValue)
    },
    'searchOptions.rentalcompanyId'(newVal) {
      this.onLoad(1)
    },
    identifier() {
      this.onLoad(1)
    },
  },

  mounted() {
    this.onLoad(1)
  },

  methods: {
    openModal(item) {
      this.$emit('open-modal', {batchType: 'B', ...item})
      /*console.log('### item', item)
      this.isModal = true
      this.modalItem = item
      this.modalItem.detailReason = ""
      this.modalItem.batchType = item.batchType
      this.modalItem.baseDt = this.searchOptions.checkDate*/
    },
    closeSalesModal() {
      this.dialog = false
      // this.rentalcompanyId = undefined
    },
    openSalesModal(rentalId, companyName) {
      this.salesListClickAutoSettingData = {
        companyName: companyName,
        rentalcompanyId: !!rentalId ? Number(rentalId) : undefined
      }
      this.dialog = true
    },
    markConditionStyle(idx) {
      if (this.items[idx].besideCount > 1 || this.items[idx].usageCount > 1) {
        return {'backgroundColor': 'yellow'};
      }
    },
    sortOptionChange(e, type) {
      this.sortOption.sortBy[0] = e
      this.sortOption.sortDesc[0] = this.sortOption.sortDesc[0] === 'true'?'false': 'true'
      this.onLoad(1)
    },

    numberFormat(number) {
      if (!number) return '0'
      return Number(number).toLocaleString()
    },
    onSortChange(option) {
      Object.keys(option).forEach(e => {
        this.sortOption[e] = option[e]
      })
      this.onFilterChanged()
    },
    /**
     * 필터 변경
     */
    onFilterChanged() {
      this.onLoad(1)
    },

    onLoad(pageNumber) {
      this.searchOptions.pageNumber = pageNumber || 1
      this.items.splice(0, this.items.length)
      this.loadData()
      this.loadSummary()
    },
    async loadSummary() {

      this.isLoading = true
      this.$request(PATH.BATCH.CHECK_SUMMARY)
          .setObject(this.searchOptions)
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.summary = res
            this.dataTotalCount = res.totalCount
            // this.isLoading = false;
          });
    },
    loadData() {

      this.isLoading = true
      this.$request(PATH.BATCH.CHECK)
          .setObject({...this.searchOptions, ...this.sortOption})
          .catch(e => {
            this.isLoading = false;
            alert("조회 실패")
          })
          .enqueue()
          .then(res => {
            this.items.push(...res.data)
            this.isLoading = false;
          });
    },

  },
}
</script>

<style scoped>
.main-con {
  position: relative;
  width: 100%;
  height: 92%;
  overflow-y: scroll;
}

.main-con .data-table {
  position: relative;
  width: 100%;
  border-spacing: 0;
}

.main-con .data-table thead {
  position: sticky;
  top: 0;
  background: #ddd;
}

.main-con .data-table thead tr th {
  font-size: 13px;
}

.main-con .data-table tbody td {
  padding: 0.15rem;
  text-align: left;
  border: 1px solid #ccc;
  font-size: 13px;
}

.main-con .data-table tbody tr:nth-child(even) {
  background: #f5f5f5;
}

.main-con .data-table tbody tr:hover {
  background: #ddd;
}

.infinity_scroll_table_paging {
  margin-top: 10px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.loading_wrap {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
  background: rgba(0,0,0,0.5);
}
.loading {
  width: 8px;
  height: 8px;
  background: #aaaaaa;
  border-radius: 50%;
  animation: loading-cricle 1.5s infinite ease-in-out;
  display: inline-block;
  margin-right: 8px;
}

.loading:nth-child(2) {
  animation-delay: .5s;
}

.loading:nth-child(3) {
  animation-delay: 1s;
}
</style>
